import { StyledIconLink, LinkText, isUrlToPdf } from '../Link';
import { DownloadIcon, PdfIcon } from '../Icon';
import { QuickLinkItem } from './QuickLinkItem';

export interface IQuickLinkAssetProps {
	title: string;
	url: string;
}

export function QuickLinkAsset({ title, url }: IQuickLinkAssetProps) {
	return (
		<QuickLinkItem>
			<StyledIconLink href={url} target="_blank">
				<LinkText>{title}</LinkText>
				{isUrlToPdf(url) ? (
					<PdfIcon variation="highlight" />
				) : (
					<DownloadIcon variation="highlight" />
				)}
			</StyledIconLink>
		</QuickLinkItem>
	);
}
